/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Feedback_Email_LabelInputs */

const en_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const de_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail:`)
};

const fr_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail :`)
};

const es_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electronico:`)
};

const it_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const nl_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const pl_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const fi_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti:`)
};

const da_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const sv_a11y_statement_feedback_email_label = /** @type {(inputs: A11y_Statement_Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {A11y_Statement_Feedback_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_feedback_email_label = /** @type {((inputs?: A11y_Statement_Feedback_Email_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Feedback_Email_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_feedback_email_label(inputs)
	if (locale === "fr") return fr_a11y_statement_feedback_email_label(inputs)
	if (locale === "es") return es_a11y_statement_feedback_email_label(inputs)
	if (locale === "it") return it_a11y_statement_feedback_email_label(inputs)
	if (locale === "nl") return nl_a11y_statement_feedback_email_label(inputs)
	if (locale === "pl") return pl_a11y_statement_feedback_email_label(inputs)
	if (locale === "fi") return fi_a11y_statement_feedback_email_label(inputs)
	if (locale === "da") return da_a11y_statement_feedback_email_label(inputs)
	if (locale === "sv") return sv_a11y_statement_feedback_email_label(inputs)
	return en_a11y_statement_feedback_email_label(inputs)
});